import React from 'react'
import styles from './ResultFlybox.module.scss'

const ResultFlyBox = ({
    image,
    title,
    body,
    isNewLabel = false,
    buttonText = 'Learn more',
    onButtonClick,
    buttonHref,
}) => {
    const ButtonTag = buttonHref ? 'a' : 'button'

    return (
        <div className={styles.flyBox}>
            {isNewLabel && <span className={styles.newLabel}>NEW</span>}
            <div className={styles.previewWrapper}>
                <img className={styles.preview} src={image} alt={title || 'preview'} />
            </div>

            <div className={styles.content}>
                {!!title && <h3 className={styles.title}>{title}</h3>}
                {!!body && <p className={styles.body}>{body}</p>}
            </div>

            <div className={styles.actions}>
                <ButtonTag
                    className={styles.button}
                    onClick={buttonHref ? undefined : onButtonClick}
                    href={buttonHref}
                    target={buttonHref ? '_blank' : undefined}
                    rel={buttonHref ? 'noopener noreferrer' : undefined}
                >
                    {buttonText}
                </ButtonTag>
            </div>
        </div>
    )
}

export default ResultFlyBox
